 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"02940babcdc9b9a8a91208a203a463424a7f837e","4":"component---node-modules-swizec-gatsby-theme-course-platform-src-pages-404-mdx","5":"component---node-modules-swizec-gatsby-theme-course-platform-src-pages-articles-index-js","6":"component---node-modules-swizec-gatsby-theme-course-platform-src-pages-auth-0-callback-js","7":"component---node-modules-swizec-gatsby-theme-course-platform-src-pages-demo-mdx","8":"component---src-pages-animation-1-mdx","9":"component---src-pages-articles-3-key-insights-that-make-d-3-js-easy-to-learn-index-mdx","10":"component---src-pages-articles-a-drilldown-piechart-with-react-and-d-3-index-mdx","11":"component---src-pages-articles-a-trick-to-make-your-big-dataviz-load-super-fast-index-mdx","12":"component---src-pages-articles-advent-of-code-day-22-sporifica-virus-index-mdx","13":"component---src-pages-articles-animated-string-diffing-with-react-and-d-3-index-mdx","14":"component---src-pages-articles-animating-with-react-redux-and-d-3-index-mdx","15":"component---src-pages-articles-announcing-d-3-blackbox-used-3-index-mdx","16":"component---src-pages-articles-behind-the-curve-of-my-bar-donut-chart-index-mdx","17":"component---src-pages-articles-build-responsive-svg-layouts-with-reactsvgflexbox-index-mdx","18":"component---src-pages-articles-buy-a-tree-index-mdx","19":"component---src-pages-articles-candy-index-mdx","20":"component---src-pages-articles-christmas-carols-index-mdx","21":"component---src-pages-articles-christmas-gifts-index-mdx","22":"component---src-pages-articles-christmas-movies-index-mdx","23":"component---src-pages-articles-christmas-trees-index-mdx","24":"component---src-pages-articles-corona-simulation-mdx","25":"component---src-pages-articles-creating-the-perfect-rounded-edge-with-d-3-curves-index-mdx","26":"component---src-pages-articles-dancing-tree-fractal-react-index-mdx","27":"component---src-pages-articles-dataviz-saves-lives-covid-19-mdx","28":"component---src-pages-articles-declarative-d-3-charts-with-react-163-index-mdx","29":"component---src-pages-articles-declarative-d-3-transitions-with-react-163-index-mdx","30":"component---src-pages-articles-dinosaurs-software-engineers-and-cholera-what-do-they-have-in-common-index-mdx","31":"component---src-pages-articles-easy-d-3-blackbox-components-with-react-hooks-index-mdx","32":"component---src-pages-articles-experimenting-with-the-new-react-concurrent-mode-index-mdx","33":"component---src-pages-articles-fractals-in-react-index-mdx","34":"component---src-pages-articles-game-loop-hooks-mdx","35":"component---src-pages-articles-gift-stockings-index-mdx","36":"component---src-pages-articles-histogram-in-d-3-v-3-vs-d-3-v-4-index-mdx","37":"component---src-pages-articles-how-to-drive-react-state-with-d-3-transitions-for-complex-animation-index-mdx","38":"component---src-pages-articles-how-you-can-translate-any-random-d-3-example-to-react-index-mdx","39":"component---src-pages-articles-javascripts-most-popular-dataviz-library-index-mdx","40":"component---src-pages-articles-kiran-challenge-index-mdx","41":"component---src-pages-articles-livecoding-12-towards-animating-10-k-elements-with-react-index-mdx","42":"component---src-pages-articles-livecoding-13-rendering-react-components-with-canvas-index-mdx","43":"component---src-pages-articles-livecoding-19-its-hard-to-package-a-library-index-mdx","44":"component---src-pages-articles-livecoding-recap-a-new-more-versatile-react-pattern-index-mdx","45":"component---src-pages-articles-loops-are-the-hardest-index-mdx","46":"component---src-pages-articles-lumagl-pt-1-index-mdx","47":"component---src-pages-articles-mondrian-art-generator-mdx","48":"component---src-pages-articles-money-spent-index-mdx","49":"component---src-pages-articles-moores-law-mdx","50":"component---src-pages-articles-mouse-events-with-d-3-v-6-react-hooks-index-mdx","51":"component---src-pages-articles-nbody-collision-simulation-with-react-d-3-and-mobx-index-mdx","52":"component---src-pages-articles-newsletter-dataviz-mdx","53":"component---src-pages-articles-optimizing-react-choropleth-map-rendering-index-mdx","54":"component---src-pages-articles-pirates-downfall-causes-global-warming-index-mdx","55":"component---src-pages-articles-reactvr-react-360-is-great-but-maybe-not-quite-there-yet-index-mdx","56":"component---src-pages-articles-sankey-index-mdx","57":"component---src-pages-articles-serverside-rendering-a-d-3-chart-with-react-16-index-mdx","58":"component---src-pages-articles-silky-smooth-piechart-transitions-with-react-and-d-3-js-index-mdx","59":"component---src-pages-articles-smartphones-index-mdx","60":"component---src-pages-articles-tiny-react-and-d-3-flamegraph-tutorial-index-mdx","61":"component---src-pages-articles-using-d-3-js-transitions-in-react-index-mdx","62":"component---src-pages-articles-webgl-airplanes-index-mdx","63":"component---src-pages-articles-when-to-buy-gifts-index-mdx","64":"component---src-pages-articles-why-dataviz-does-better-for-your-career-than-todoapps-index-mdx","65":"component---src-pages-ball-game-1-mdx","66":"component---src-pages-building-blocks-1-mdx","67":"component---src-pages-building-blocks-2-mdx","68":"component---src-pages-building-blocks-3-mdx","69":"component---src-pages-building-blocks-4-mdx","70":"component---src-pages-building-blocks-5-mdx","71":"component---src-pages-canvas-game-1-mdx","72":"component---src-pages-choropleth-map-1-mdx","73":"component---src-pages-cookbook-1-mdx","74":"component---src-pages-cookbook-10-mdx","75":"component---src-pages-cookbook-11-mdx","76":"component---src-pages-cookbook-12-mdx","77":"component---src-pages-cookbook-13-mdx","78":"component---src-pages-cookbook-14-mdx","79":"component---src-pages-cookbook-15-mdx","80":"component---src-pages-cookbook-17-mdx","81":"component---src-pages-cookbook-18-mdx","82":"component---src-pages-cookbook-2-mdx","83":"component---src-pages-cookbook-3-mdx","84":"component---src-pages-cookbook-4-mdx","85":"component---src-pages-cookbook-5-mdx","86":"component---src-pages-cookbook-6-mdx","87":"component---src-pages-cookbook-7-mdx","88":"component---src-pages-cookbook-8-mdx","89":"component---src-pages-cookbook-9-mdx","90":"component---src-pages-d-3-quick-intro-1-mdx","91":"component---src-pages-d-3-quick-intro-2-mdx","92":"component---src-pages-d-3-quick-intro-6-mdx","93":"component---src-pages-enter-update-exit-1-mdx","94":"component---src-pages-finished-1-mdx","95":"component---src-pages-game-loops-1-mdx","96":"component---src-pages-index-mdx","97":"component---src-pages-introduction-1-mdx","98":"component---src-pages-introduction-2-mdx","99":"component---src-pages-introduction-3-mdx","100":"component---src-pages-introduction-4-mdx","101":"component---src-pages-introduction-5-mdx","102":"component---src-pages-introduction-7-mdx","103":"component---src-pages-load-parse-data-1-mdx","104":"component---src-pages-local-environment-1-mdx","105":"component---src-pages-local-environment-4-mdx","106":"component---src-pages-make-it-work-1-mdx","107":"component---src-pages-meta-info-1-mdx","108":"component---src-pages-preloader-1-mdx","109":"component---src-pages-react-d-3-1-mdx","110":"component---src-pages-react-d-3-2-mdx","111":"component---src-pages-react-d-3-7-mdx","112":"component---src-pages-react-hooks-1-mdx","113":"component---src-pages-react-hooks-2-mdx","114":"component---src-pages-react-hooks-3-mdx","115":"component---src-pages-react-hooks-4-mdx","116":"component---src-pages-redux-animation-1-mdx","117":"component---src-pages-salaries-histogram-1-mdx","118":"component---src-pages-simple-animation-1-mdx","119":"component---src-pages-smooth-animation-1-mdx","120":"component---src-pages-speed-optimizations-1-mdx","121":"component---src-pages-state-app-structure-1-mdx","122":"component---src-pages-state-app-structure-4-mdx","123":"component---src-pages-state-app-structure-5-mdx","124":"component---src-pages-tech-salaries-1-mdx","125":"component---src-pages-thanks-basics-mdx","126":"component---src-pages-thanks-extra-mdx","127":"component---src-pages-thanks-full-mdx","128":"component---src-pages-user-control-1-mdx","129":"component---src-pages-using-canvas-1-mdx","130":"component---src-pages-using-canvas-5-mdx","131":"component---src-pages-workshop-advanced-transitions-mdx","132":"component---src-pages-workshop-blackbox-mdx","133":"component---src-pages-workshop-d-3-101-mdx","134":"component---src-pages-workshop-full-integration-mdx","135":"component---src-pages-workshop-hooks-101-mdx","136":"component---src-pages-workshop-index-mdx","137":"component---src-pages-workshop-manual-animation-mdx","138":"component---src-pages-workshop-outro-mdx","139":"component---src-pages-workshop-transitions-mdx"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
